import _ from 'lodash';
import {IS_COMMUNICATING, IS_DEVICE_ONLINE, SHOW_IMAGE, UPDATE_NETWORK_REQUEST} from './types';

export const isDeviceOnline = (isOnline) => {
    return {
        type: IS_DEVICE_ONLINE,
        payload: isOnline,
    };
};

export const communicating = (isCommunicating) => {
    return {
        type: IS_COMMUNICATING,
        payload: isCommunicating,
    };
};
export const showImage = (payload) => {
    return {
        type: SHOW_IMAGE,
        payload,
    };
};

export const updateNetworkRequest = (object) => {
    return dispatch => {
        dispatch({
            type: UPDATE_NETWORK_REQUEST,
            payload: object,
        });
        let delay = !_.isEmpty(object) && object.status === 'success' ? 2000 : 4000;
        if (!_.isEmpty(object) && object.status !== 'loading') {
            setTimeout(() => {
                dispatch(updateNetworkRequest(null));
                if (object.redirect) {
                    object.redirect();
                }
            }, delay);
        }
    };

};
